// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"ce18efdd","101":"2f8d9615","132":"329a5a1b","195":"c71d31ab","255":"6e40cdd4","389":"8f2c6f03","422":"b917ad53","464":"0b4e69f6","594":"996c2c84","931":"170338fc","982":"f72b2d62"}[chunkId] + ".chunk.js";
};